import {
  PAGES_WITH_AI_SEARCH,
  PageType,
  RevelioPageId,
} from '../../components/PageConfigProvider/types';
import { isScreenerV2Page } from '../../utils/routing-helpers';
import { FilterId } from '../types/filters';

const AI_SEARCH_PRIMARY_FILTER_IDS: ReadonlySet<FilterId> = new Set([
  FilterId.COMPANY,
  FilterId.GEOGRAPHY,
  FilterId.ROLE,
]);

type ShouldShowAiSearchForPageArgs = {
  pageType: PageType;
  revelioPageId: RevelioPageId | undefined;
  primaryFilterId: FilterId | undefined;
  isAiSearchWiderDashboardEnabled: boolean;
};

export const shouldShowAiSearchForPage = ({
  pageType,
  revelioPageId,
  primaryFilterId,
  isAiSearchWiderDashboardEnabled,
}: ShouldShowAiSearchForPageArgs): boolean => {
  const isPrivatePageWithAiSearchPrimaryFilter =
    pageType === PageType.PRIVATE &&
    primaryFilterId !== undefined &&
    AI_SEARCH_PRIMARY_FILTER_IDS.has(primaryFilterId);

  const hasRevelioPageId = Boolean(revelioPageId);
  const isScreenerPage = isScreenerV2Page(revelioPageId);
  const isAiSearchPage = revelioPageId
    ? PAGES_WITH_AI_SEARCH.includes(revelioPageId)
    : false;

  return (
    isPrivatePageWithAiSearchPrimaryFilter ||
    (hasRevelioPageId &&
      (revelioPageId === RevelioPageId.TALENT_DISCOVERY ||
        revelioPageId === RevelioPageId.POSTING_DISCOVERY ||
        isScreenerPage ||
        (isAiSearchWiderDashboardEnabled && isAiSearchPage)))
  );
};
